import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "card" ]
  initialize() {
    // console.log("Hover controller is working!");
  }
  connect() { 
    function addOpacity(targets, except) {
      targets.forEach((el, index) => { 
        if (except !== index) {
          el.classList.add("opacity-50");
        }
      });
    }
    function removeOpacityAll(targets) {
      targets.forEach((el) => { 
        el.classList.remove("opacity-50");
      });
    }

    this.cardTargets.forEach((el, index) => {
      el.addEventListener("mouseover", () => {
        addOpacity(this.cardTargets, index)
      });
      el.addEventListener("mouseout", () => {
        removeOpacityAll(this.cardTargets);
      });
    });
  }
  
}